// Version : 1.0.0
// Author : AGALYA
import ExtraInformationActionType from './extra-information.types';

/** ***************** EXTRA INFORMATION ADD START *********************** */
export const extraInformationAddStart = (extraInformationCredentials: any) => ({
	type: ExtraInformationActionType.EXTRA_INFORMATION_ADD_START,
	payload: extraInformationCredentials,
});

export const extraInformationAddSuccess = (extraInformationSuccess: any) => ({
	type: ExtraInformationActionType.EXTRA_INFORMATION_ADD_SUCCESS,
	payload: extraInformationSuccess,
});

export const extraInformationAddFailure = (extraInformationFailure: unknown) => ({
	type: ExtraInformationActionType.EXTRA_INFORMATION_ADD_FAILURE,
	payload: extraInformationFailure,
});

export const extraInformationAddResponseResetStart = () => ({
	type: ExtraInformationActionType.EXTRA_INFORMATION_ADD_RESPONSE_REST_START,
});

export const extraInformationAddUserResponseChanged = () => ({
	type: ExtraInformationActionType.EXTRA_INFORMATION_ADD_RESPONSE_CHANGED,
});
/** ***************** EXTRA INFORMATION ADD END *********************** */
